import { graphql } from "../generated";

export const GetLine = graphql(
  `
    query GetLine($filter: SearchableLinesFilterInput!) {
      searchAuthorizedLines(filter: $filter) {
        items {
          ...LineDetails
        }
      }
    }
  `
);
